import React, { useState, useEffect } from "react";

import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Table, Button, Container, Modal, Form, ButtonGroup, Pagination, Spinner } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import ErrorModal from './ErrorModal';
import CustomModal from './CustomModal';

const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}; 

const BoardNotifications = () => {
  
  const [customers, setCustomers] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedNotifications, setSelectedNotifications] = useState(null);
  const [deleteState, setDeleteState] = useState(false);
  const [errors, setErrors] = useState({}); // Error state
  const [apierrors, setApiErrors] = useState('');// Error state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filterTerm, setFilterTerm] = useState('');
  
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(' Lade, bitte warten...');
  const [showModal, setShowModal] = useState(false);
  const [errorCode, setApiErrorCode] = useState('');// Error state

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // Set items per page


  const [formData, setFormData] = useState({
    
  });

  const validateForm = () => {
    const newErrors = {};
    if (!formData.recipient_email || !isValidEmail(formData.recipient_email)) {
      newErrors.recipient_email = 'Gültige E-Mail ist erforderlich';
    }
    if (!formData.subject || formData.subject.length < 3) {
      newErrors.subject = 'Betreff sollte mindestens 3 Zeichen lang sein';
    }
    if (!formData.body || formData.body.length < 10) {
      newErrors.body = 'Text sollte mindestens 10 Zeichen lang sein';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    
    UserService.getNotificationBoard().then(
      (response) => {
        setNotifications(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Error: No response received from the server.');
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Error: ${error.response.data.message}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } 

          setNotifications(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        

      
});
UserService.getCustomerBoard().then(
  (response) => {
    setCustomers(response.data);
  },
  (error) => {
    const _content =
      (error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message ||
      error.toString();

      if (error.response) {
        // Server responded with a status other than 200 range
        setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
        setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      } else if (error.request) {
        // Request was made, but no response was received
        setApiErrors('Error: No response received from the server.');
        setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      } else {
        // Other types of errors
        setApiErrors(`Error: ${error.response.data.message}`);
        setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      } 

      setCustomers(_content);

    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
    
    
  
});
  }, [deleteState]);


// Filter the mainvos based on the filter input
const filteredMainVOs = Array.isArray(notifications)
    ? notifications.filter((vo) =>
        (vo.recipient_email && vo.recipient_email.toLowerCase().includes(filterTerm.toLowerCase())) ||
    (vo.body && vo.body.toLowerCase().includes(filterTerm.toLowerCase())) ||
    (vo.status && vo.status.toLowerCase().includes(filterTerm.toLowerCase())) ||
    (vo.failure_reason && vo.failure_reason.toLowerCase().includes(filterTerm.toLowerCase())) ||    
    
    (vo.createdAt && vo.createdAt.toLowerCase().includes(filterTerm.toLowerCase())) ||   
    (vo.subject && vo.subject.toLowerCase().includes(filterTerm.toLowerCase()))
        
      )
    : [];

// Get the current page's data
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentMainVOs = filteredMainVOs.slice(indexOfFirstItem, indexOfLastItem);

 // Handle pagination
const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

// Sorting function
const handleSort = (key) => {
  let direction = 'asc';
  if (sortConfig.key === key && sortConfig.direction === 'asc') {
    direction = 'desc';
  }
  setSortConfig({ key, direction });
};


// Sort the filtered data
const sortedMainVOs = [...filteredMainVOs].sort((a, b) => {
  if (a[sortConfig.key] < b[sortConfig.key]) {
    return sortConfig.direction === 'asc' ? -1 : 1;
  }
  if (a[sortConfig.key] > b[sortConfig.key]) {
    return sortConfig.direction === 'asc' ? 1 : -1;
  }
  return 0;
});


// Total pages calculation
const totalPages = Math.ceil(filteredMainVOs.length / itemsPerPage);


  const handleEditClick = (currency) => {
    setApiErrors(null);
    setApiErrorCode(null);
    setSelectedNotifications(currency)
    setFormData(currency);
    setShowEditModal(true);
  };

  const handleCreateClick = () => {
    setApiErrors(null);
    setApiErrorCode(null);
    setFormData({
      
    });
    setShowCreateModal(true);
  };

  const isValidDate = (date) => {
    return !isNaN(Date.parse(date));
  };

  const handleDeleteClick = async (id,e) => {
    e.preventDefault();
    setApiErrors(null);
    setApiErrorCode(null);
    try {
      setLoadingText('Daten werden gelöscht, bitte warten...');
      setLoading(true);
      await UserService.deleteNotificationBoard(id);
      setDeleteState(prev => !prev);
      console.info(deleteState);
    } catch (error) {
      setApiErrors(`Error: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      setShowModal(true);

      console.error('Error deleting Notifcation:', error);
    }
    finally {
      setLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      formData.rec_date = new Date();
      setLoadingText('Daten werden aktualisiert, bitte warten...');
      setLoading(true);
      await UserService.updateCurrencyBoard(selectedNotifications.notification_id,formData);
      setDeleteState(prev => !prev);
      setShowEditModal(false);
    } catch (error) {
      setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      console.error('Error creating Notification:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      
      formData.rec_date = new Date();
      const recDate = formData.createdAt;
      const validDate = isValidDate(recDate) ? recDate : null;     
      formData.createdAt = validDate;
      setLoadingText('Daten werden erstellt, bitte warten...');
      setLoading(true);
      await UserService.sendNotificationBoard(formData);
      setDeleteState(prev => !prev);
      setShowCreateModal(false);
      
    } catch (error) {
      setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      console.error('Error creating Notification:', error);
      setDeleteState(prev => !prev);
      setShowModal(true);
      setShowCreateModal(false);
    }
    finally {
      setLoading(false);
    }
  };

  const handleBlur = () => {
    validateForm();
 };

 const handleChange = (e) => {
   setFormData({
     ...formData,
     [e.target.name]: e.target.value
   });
 validateForm();
 };

 const handleCloseModal = () => setShowModal(false);

  return (
    <Container>
      <h1 className="mt-5">Benachrichtigungsübersicht</h1>
      {/* Display error if it exists */}
      <ErrorModal show={showModal} handleClose={handleCloseModal} errorCode={errorCode} errorMessage={apierrors} />
      {/*<Button variant="info" onClick={() => handleCreateClick()} className="mr-2 mb-2">
                  Erstellen
      </Button>*/}
      {loading && (
        <div className="spinner-overlay">
         <div className="spinner-background">
          <Spinner animation="border" role="status" className="spinner-border">
            <span className="sr-only">Lade...</span>
          </Spinner>
          <div className="spinner-text">...{loadingText}</div>
          </div>
        </div>
      )}

      {/* Filter Input */}
      <Form.Group controlId="formBasicSearch">
        <Form.Control
          type="text"
          placeholder="Suche nach Betreff, Nachricht, Datum..."
          value={filterTerm}
          onChange={(e) => setFilterTerm(e.target.value)}
        />
      </Form.Group>
      {/* Table */}
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            {/* Sortable column headers */}
            <th onClick={() => handleSort('notification_id')} style={{ cursor: 'pointer' }}>
            Benachrichtigungs-ID {sortConfig.key === 'notification_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('recipient_email')} style={{ cursor: 'pointer' }}>
            Empfänger {sortConfig.key === 'recipient_email' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('subject')} style={{ cursor: 'pointer' }}>
            Betreff {sortConfig.key === 'subject' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('body')} style={{ cursor: 'pointer' }}>
            Text {sortConfig.key === 'body' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('status')} style={{ cursor: 'pointer' }}>
            Status {sortConfig.key === 'status' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('failure_reason')} style={{ cursor: 'pointer' }}>
            Fehlergrund {sortConfig.key === 'failure_reason' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('createdAt')} style={{ cursor: 'pointer' }}>
            Erstellt am {sortConfig.key === 'createdAt' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {sortedMainVOs.map((currency) => (
     
            <tr key={currency.notification_id}>
              <td>{currency.notification_id}</td>
              <td>{currency.recipient_email}</td>
              <td>{currency.subject}</td>
              <td><div dangerouslySetInnerHTML={{ __html: currency.body }} /></td>
              <td>{currency.status}</td>
              <td>{currency.failure_reason}</td>
              <td>{currency.createdAt}</td>
              
              <td>
              <ButtonGroup>
                <Button variant="danger" onClick={(e) => handleDeleteClick(currency.notification_id,e)} title="Löschen" aria-label="Löschen">
                  <FaTrash />
                </Button>
                </ButtonGroup>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination>
        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />

        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item
            key={index}
            active={index + 1 === currentPage}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}

        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>
      {/* Create Modal */}
      {/*<CustomModal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        title="Neue Benachrichtigung erstellen"
        formData={formData}
        handleChange={handleChange}
        handleBlur={handleBlur}
        errors={errors}
        handleSubmit={handleCreateSubmit}
        loading={loading}
        buttonLabel="Benachrichtigung speichern"
        formFields={[
          { name: 'recipient_email', label: 'Empfänger-E-Mail', type: 'email', placeholder: 'Empfänger-E-Mail eingeben' },
          { name: 'subject', label: 'Betreff', type: 'text', placeholder: 'E-Mail-Betreff eingeben' },
          { name: 'body', label: 'E-Mail-Text', type: 'textarea', placeholder: 'E-Mail-Text eingeben' },
          {
            name: 'customer_id',  // The field name that corresponds to your state object.
            label: 'Kunde auswählen',
            type: 'select',       // Define the type as select to render a dropdown.
            placeholder: 'Kunde auswählen',
            options: customers.map(mvos => ({ value: mvos.customer_id, label: mvos.custumer_company_name }))  // Create options array.
          }
        ]}
      />
    */}

      
  
    </Container>
  );
};

export default BoardNotifications;